<template>
	<el-dialog :visible.sync="show"
		:title="$t('privateNetwork.createTitle')"
		:close-on-click-modal="false"
		:before-close="handleClose"
		class="create-root">
		<el-form :model="createForm"
			ref="create"
			:rules="rules"
			label-position="right"
			label-width="120px">
			<!-- 地域 -->
			<el-form-item :label="$t('privateNetwork.region') | withColon">
				<el-radio-group v-model="createForm.region" @change="regionChange">
					<el-tooltip
						v-for="(region,index) in regionsList"
						:key="index"
						:content="$t('slb.sentence.fullTip')"
						:disabled="!region.disabled"
						:visible-arrow="false"
						:offset="110"
						placement="bottom">
						<span>
							<el-radio-button
								:label="region.region"
								:disabled="region.disabled">
								{{region.regionName}}
							</el-radio-button>
						</span>
					</el-tooltip>
				</el-radio-group>
				<el-tooltip :content="$t('privateNetwork.createTip')" placement="right">
					<a><i class="jc-icon-question"></i></a>
				</el-tooltip>
				<p slot="hint"
					v-if="tipShow"
					class="create-tip">
					{{$t('eip.help.soldOut')}}
					<a v-bind:href="Config.WORK_URL" target="_blank">{{$t('eip.help.openTicket')}}</a>
					{{$t('eip.help.increaseLimit')}}
				</p>
			</el-form-item>
			<!-- 名称 -->
			<el-form-item :label="$t('privateNetwork.name') | withColon"
				prop="name">
				<el-input v-model="createForm.name"></el-input>
				<p slot="hint">{{ $t('privateNetwork.nameHelp') }}</p>
			</el-form-item>
			<!-- IPv4CIDR -->
			<el-form-item :label="$t('privateNetwork.segment') | withColon" required>
				<my-cidr
					:cidrArray="[cidrVal.cidr1Val, cidrVal.cidr2Val, cidrVal.cidr3Val, cidrVal.cidr4Val, cidrVal.cidr5Val]"
					@cidrValsInArray="cidrChange" class="my-cidr">
				</my-cidr>
				<p slot="hint" class="cidr-tip">
					<i class="jc-icon-question">
						{{ $t('privateNetwork.notChange') }}
					</i>
				</p>
			</el-form-item>
			<!-- IPv6CIDR -->
			<el-form-item :label="$t('privateNetwork.ipv6Cidr') | withColon" required>
				<el-radio-group v-model="createForm.ipv6Cidr">
				    <el-radio :label="item.value" v-for="item in ipv6Choose" :key="item.value">{{item.label}}</el-radio>
				</el-radio-group>
				<p slot="hint" v-if="ipv6CidrTip">{{ $t('privateNetwork.ipv6CidrHelp') }}</p>
			</el-form-item>
			<el-form-item :label="$t('privateNetwork.description') | withColon"
				prop="description">
				<el-input type="textarea"
					v-model="createForm.description">
				</el-input>
				<p slot="hint">{{ $t('privateNetwork.descriptionHelp') }}</p>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button @click="cancelCreate">{{ $t('privateNetwork.cancel') }}</el-button>
			<el-button @click="sureCreate('create')" type="primary" :disabled="tipShow">{{ $t('privateNetwork.sure') }}
			</el-button>
		</div>
	</el-dialog>
</template>

<script>

import myCidr from '../../common/cidr/Cidr';
import { validateName } from '@/common/dataHelper';
import { ServiceCodeConstant } from "@/common/Constants";

export default {
	name: 'CreatePrivateSub',
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		regions: {
			type: Array,
			default: () => []
		},
		initRegion: {
			type: String,
			default: ''
		}
	},
	components: {
		myCidr
	},

	data() {
		const valName = (rule, value, callback) => {
			if (!validateName(value)) {
				callback(this.$t('privateNetwork.nameHelp'));
			} else {
				this.checkVpcName(value).then((isDuplication) => {
					if (isDuplication) {
						callback(new Error(this.$t('slb.serverGroup.nameDuplicate')));
					} else {
						callback();
					}
				});
			}
		};
		const valDes = (rule, value, callback) => {
			if (!/^.{0,256}$/.test(value)) {
				callback(this.$t('privateNetwork.descriptionHelp'));
			} else {
				callback();
			}
		};
		return {
			tipShow: false, // 是否显示配额不足提示
			tableList: [],
			show: this.visible,
			regionsList: [],
			ipv6Choose: [ // 是否开通ipv6
				{
					value: 'no',
					label: this.$t('privateNetwork.close')
				},
				{
					value: 'yes',
					label: this.$t('privateNetwork.open')
				},
			],
			ipv6CidrTip: false,
			createForm: {
				region: '',
				name: '',
				cidr: '10.0.0.0/16',
				segment: '',
				ipv6Cidr: 'no',
				description: '',
			},
			cidrDefaultVal: {
				cidr1Val: 10,
				cidr2Val: 0,
				cidr3Val: 0,
				cidr4Val: 0,
				cidr5Val: 16
			},
			cidrVal: {
				cidr1Val: 10,
				cidr2Val: 0,
				cidr3Val: 0,
				cidr4Val: 0,
				cidr5Val: 16
			},
			rules: {
				name: [
					{ required: true, message: this.$t('privateNetwork.nameNotNull'), trigger: 'blur' },
					{ validator: valName, trigger: 'blur' },
				],
				description: [
					{ validator: valDes, trigger: 'blur' }
				]
			},
			regionDisabledStatus: {} // 保存区域按钮是否可见状态
		};
	},
	watch:{
		'createForm.ipv6Cidr': function(val) {
			this.ipv6CidrTip = !this.ipv6CidrTip
		}
	},
	created() {
		this.createForm.region = this.initRegion;
		this.getRegions();
	},
	methods: {
		/**
		 * 检查名称是否重复
		 * @param name
		 * @return String
		 */
		async checkVpcName(name) {
			const params = {
				region: this.createForm.region,
				name
			};
			const json = await Ajax.get('/api/cps/checkVpcName', params)
				.then(res => res.data.success);
			return json;
		},
		/**
		 * 根据不同区域获得vpc配额
		 * @return {number}
		 */
		async getVpcQuota() {
			const defaultParams = {
				serviceCode: ServiceCodeConstant.CPSVPC
			};
			const availableCount = await Ajax.get('/api/bm/getUserQuotas', defaultParams)
				.then(res => res.data.userQuotas[this.createForm.region])
				.catch(async (err) => {
					const response = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				});
			return availableCount;
		},
		/**
		 * 改变区域时回调
		 */
		regionChange() {
			Object.keys(this.regionDisabledStatus).forEach((item) => {
				this.regionsList.forEach((region) => {
					if (region.region === item) {
						region.disabled = this.regionDisabledStatus[item];
					}
				});
			});
			this.getVpcQuota().then((quota) => {
				this.regionDisabledStatus[this.createForm.region] = quota === 0;
				this.tipShow = quota === 0;
			});
		},
		formatDefault() {
			for (const key in this.createForm) {
				if (this.createForm.hasOwnProperty(key)) {
					this.createForm[key] = '';
				}
			}
			for (const key in this.cidrVal) {
				if (this.cidrVal.hasOwnProperty(key)) {
					this.cidrVal[key] = this.cidrDefaultVal[key];
				}
			}
		},
		handleClose() {
			this.formatDefault();
			this.show = false;
			this.$emit('update:visible', false);
		},
		cancelCreate() {
			this.handleClose();
		},
		sureCreate(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					const clientToken = Normal.getClientToken();
					const params = {
						region: this.createForm.region,
						name: this.createForm.name,
						cidr: this.createForm.cidr,
						description: this.createForm.description,
						enableIpv6: this.createForm.ipv6Cidr,
						clientToken
					};
					Ajax.put('/api/cps/vpcs', params)
					.then((res) => {
						if (res.errno === 10000 && res.data) {
							this.$emit('refresh');
						}
					})
					.catch(async err => {
						const { response } = err.data;
		                const json = await response.json();
		                if (json.errno === 20154) {
		                	this.$message.error(json.errmsg);
		                }
					})
					.finally(() => {
						this.handleClose();
					});
				} else {
					return false;
				}
			});
		},
		cidrChange(cidrValsInArray) {
			const target = this;
			[target.cidrVal.cidr1Val, target.cidrVal.cidr2Val, target.cidrVal.cidr3Val, target.cidrVal.cidr4Val, target.cidrVal.cidr5Val] = cidrValsInArray;
			this.createForm.cidr = cidrValsInArray.join('.').replace(/.([^.]*)$/, '/' + '$1');
		},
		getRegionByName(name) {
			let tempRegion;
			this.regions.forEach((region) => {
				if (region.regionName === name) {
					tempRegion = region.region;
				}
			});
			return tempRegion;
		},
		getRegions() {
			const params = {
				networkType: 'vpc'
			};
			Ajax.get('api/cps/getRegions', params).then((res) => {
				if (res.data) {
					this.regionsList = res.data.regions.map(region => ({
						region: region.region,
						regionName: region.regionName,
						disabled: false
					}));
				}
			}).then(() => {
				this.getVpcQuota().then((quota) => {
					this.regionDisabledStatus[this.createForm.region] = quota === 0;
					this.tipShow = quota === 0;
					Object.keys(this.regionDisabledStatus).forEach((item) => {
						this.regionsList.forEach((region) => {
							if (region.region === item) {
								region.disabled = this.regionDisabledStatus[item];
							}
						});
					});
				});
			});
		},
	},
};
</script>

<style lang="scss">
	@import "createPrivateSub";
</style>



// WEBPACK FOOTER //
// src/components/privateNetwork/createPrivateSub/CreatePrivateSub.vue